import {
  isAcceptableImageUploadContentType,
  isAcceptablePdfUploadContentType,
} from "@src/appV2/lib/files/utils";
import { PdfViewerProvider } from "@src/appV2/PdfViewer/context";
import { PdfViewer } from "@src/appV2/PdfViewer/PdfViewer";
import { type UploadedFile } from "@src/appV2/redesign/Documents/useFileUploaderContext";

import { PreviewNotAvailable } from "./PreviewNotAvailable";
import { ZoomableImage } from "./ZoomableImage";

interface FilePreviewProps {
  file: UploadedFile;
}

export function FilePreview(props: FilePreviewProps) {
  const { file } = props;

  if (isAcceptableImageUploadContentType(file.contentType)) {
    return <ZoomableImage src={file.dataUrlBase64} alt="File preview" />;
  }

  if (isAcceptablePdfUploadContentType(file.contentType)) {
    return (
      <PdfViewerProvider fileName={`preview.${file.extension}`} pdfUrl={file.dataUrlBase64}>
        <PdfViewer
          toolbarActions={{ showPageInfo: true, showZoom: true, showDownload: false }}
          sx={{ alignSelf: "stretch", height: "100%" }}
        />
      </PdfViewerProvider>
    );
  }

  return <PreviewNotAvailable fileContentType={file.contentType} fileExtension={file.extension} />;
}
